import { buildAxiosInstance, buildMakeUseAxios } from "@root/api/api.tools";

const INTERVIEW_EXIT_BASE_URL = `${import.meta.env.VITE_CANDIDATE_SERVICE_URL}`;
export const interviewExitAxiosInstance = buildAxiosInstance(INTERVIEW_EXIT_BASE_URL);
export const useAxiosInterviewExit = buildMakeUseAxios(INTERVIEW_EXIT_BASE_URL);
